/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';

import ResponseSelectMenu from './ResponseSelectMenu.jsx';

const mapStateToProps = (state, ownProps) => {
  const { edpKey, form, externalAutofillSource } = ownProps;

  const { makeFieldIsAutofilledSelector, selectResponsesForEdp } = modelTypesByForm[form];
  const selectFieldIsAutofilled = makeFieldIsAutofilledSelector();

  const autofilled = selectFieldIsAutofilled(state, { name: externalAutofillSource });
  const responses = selectResponsesForEdp(state, { edpKey });

  return {
    disabled: autofilled,
    responses,
  };
};

export default connect(mapStateToProps)(ResponseSelectMenu);
